import React, {useState} from "react";
import {readableDate} from "../../utils";
import { Button } from "@allxsmith/bestax-bulma";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";


export default function DepositRefundRow({rental, onPayed, index, onChange, onSave, getMissingOffHireItems}){
    const [editable, setEditable] = useState(false)


    return (
        <tr onClick={() => window.open(`/editrental/${rental.id}`, "_self")} className={"clickable"}>
            <td>{rental.id}</td>
            <td>{rental.vehicle ? rental.vehicle.registration : ""}</td>
            <td>{rental.payer ? rental.payer.display_name : rental.customer ? rental.customer.display_name : ""}</td>
            <td>{readableDate(rental.off_hire_date)}</td>
            {/*{useEditableTableCostCell({*/}
            {/*    propName: "deposit_refunded_amount",*/}
            {/*    value: rental.deposit_refunded_amount,*/}
            {/*    onChange: e => onChange(e, index),*/}
            {/*    onSave: () => onSave(rental),*/}
            {/*    editable,*/}
            {/*    setEditable,*/}
            {/*    inlineEdit: true*/}
            {/*})}*/}
            <td>£{rental.deposit}</td>
            <td>£{rental.customer_deposit_paid_amount}</td>
            <td>£{rental.deposit_refunded_amount}</td>
            <td>{getMissingOffHireItems(rental)}</td>
            <td onClick={e => e.stopPropagation()}>
                <Button
                    color={"success"}
                    onClick={() => onPayed(rental)}
                >
                    PAID
                </Button>
            </td>
        </tr>
    )
}